import $ from 'jquery';
import 'bootstrap/js/modal';
import amplitude from 'application/trackable/amplitude';

function mountParams() {
  return {
    systemName: 'quero-bolsa',
    pagePath: window.location.pathname,
    system: 'quero-bolsa',
  };
}

export default function hookAmplitudeEvents() {
  const helpCenterAttendanceLink = $('.js-help-center-link');
  const whatsAppAttendanceLink = $('.js-whats-app-attendance-link');
  const phoneAttendanceLink = $('.js-phone-attendance-link');
  const helpAttendenceLink = $('.js-help-link');

  helpCenterAttendanceLink.on('click', () => {
    amplitude.track('ClickedHelpCenterLink', mountParams());
  });

  whatsAppAttendanceLink.on('click', () => {
    amplitude.track('ClickedWhatsAppAttendance', mountParams());
  });

  phoneAttendanceLink.on('click', () => {
    amplitude.track('ClickedPhoneAttendance', mountParams());
  });

  helpAttendenceLink.on('click', () => {
    amplitude.track('ClickedHelpAttendance', mountParams());
  });
}
